"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var attach_listener_1 = require("./attach-listener");
var constants_1 = require("./constants");
var create_or_join_1 = require("./create-or-join");
var get_url_1 = require("./get-url");
var proxy_1 = require("./proxy");
exports.useWebSocket = function (url, options) {
    if (options === void 0) { options = constants_1.DEFAULT_OPTIONS; }
    var _a = react_1.useState(null), lastMessage = _a[0], setLastMessage = _a[1];
    var _b = react_1.useState({}), readyState = _b[0], setReadyState = _b[1];
    var convertedUrl = react_1.useRef(null);
    var webSocketRef = react_1.useRef(null);
    var startRef = react_1.useRef(null);
    var reconnectCount = react_1.useRef(0);
    var messageQueue = react_1.useRef([]);
    var expectClose = react_1.useRef(false);
    var webSocketProxy = react_1.useRef(null);
    var staticOptionsCheck = react_1.useRef(false);
    var readyStateFromUrl = convertedUrl.current && readyState[convertedUrl.current] !== undefined ?
        readyState[convertedUrl.current] :
        url !== null ?
            constants_1.ReadyState.CONNECTING :
            constants_1.ReadyState.UNINSTANTIATED;
    var sendMessage = react_1.useCallback(function (message) {
        if (webSocketRef.current && webSocketRef.current.readyState === constants_1.ReadyState.OPEN) {
            webSocketRef.current.send(message);
        }
        else {
            messageQueue.current.push(message);
        }
    }, []);
    var getWebSocket = react_1.useCallback(function () {
        if (options.share !== true) {
            return webSocketRef.current;
        }
        if (webSocketProxy.current === null) {
            webSocketProxy.current = proxy_1.default(webSocketRef.current, startRef);
        }
        return webSocketProxy.current;
    }, [options.share]);
    react_1.useEffect(function () {
        if (url !== null) {
            var removeListeners_1;
            var start_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            expectClose.current = false;
                            _a = convertedUrl;
                            return [4 /*yield*/, get_url_1.getUrl(url, options)];
                        case 1:
                            _a.current = _b.sent();
                            create_or_join_1.createOrJoinSocket(webSocketRef, convertedUrl.current, setReadyState, options);
                            removeListeners_1 = attach_listener_1.attachListeners(webSocketRef.current, convertedUrl.current, {
                                setLastMessage: setLastMessage,
                                setReadyState: setReadyState,
                            }, options, startRef.current, reconnectCount, expectClose, sendMessage);
                            return [2 /*return*/];
                    }
                });
            }); };
            startRef.current = function () {
                var _a;
                expectClose.current = true;
                if (webSocketProxy.current)
                    webSocketProxy.current = null;
                (_a = removeListeners_1) === null || _a === void 0 ? void 0 : _a();
                start_1();
            };
            start_1();
            return function () {
                var _a;
                expectClose.current = true;
                if (webSocketProxy.current)
                    webSocketProxy.current = null;
                (_a = removeListeners_1) === null || _a === void 0 ? void 0 : _a();
            };
        }
    }, [url, sendMessage]);
    react_1.useEffect(function () {
        if (options.enforceStaticOptions !== false && staticOptionsCheck.current) {
            throw new Error('The options object you pass must be static');
        }
        staticOptionsCheck.current = true;
    }, [options]);
    react_1.useEffect(function () {
        if (readyStateFromUrl === constants_1.ReadyState.OPEN) {
            messageQueue.current.splice(0).forEach(function (message) {
                sendMessage(message);
            });
        }
    }, [readyStateFromUrl]);
    return [sendMessage, lastMessage, readyStateFromUrl, getWebSocket];
};
//# sourceMappingURL=use-websocket.js.map